"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentReact = exports.Document = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DocumentReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(DocumentReact, _React$Component);
  var _super = _createSuper(DocumentReact);
  function DocumentReact() {
    (0, _classCallCheck2.default)(this, DocumentReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(DocumentReact, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        siteInfo = _this$props.siteInfo,
        document = _this$props.document;
      var iframeURL = document.iframeURL,
        BROWSER_SUPPORT_MESSAGE = document.BROWSER_SUPPORT_MESSAGE;
      var hasPdfPlugin = siteInfo.hasPdfPlugin,
        basePath = siteInfo.basePath;
      var queryStr = "".concat(iframeURL.split('?')[1] ? '&' : '?', "hasPdfPlugin=true");
      var docIframeURL = "".concat(basePath).concat(iframeURL).concat(queryStr);
      var linkURL = "".concat(basePath).concat(iframeURL) === '' ? null : /*#__PURE__*/_react.default.createElement("a", {
        href: docIframeURL,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Click here to download and print the entire PDF.");
      var embedTag = "".concat(basePath).concat(iframeURL) === '' ? null : /*#__PURE__*/_react.default.createElement("div", {
        id: "document-container"
      }, /*#__PURE__*/_react.default.createElement("embed", {
        id: "document-iframe",
        src: docIframeURL,
        type: "application/pdf",
        width: "100%",
        height: "100%"
      }));
      // The below is the same implementation for above but with Object tag
      // const embedTag = `${basePath}${iframeURL}` === '' ? (<div></div>) : (<div id='document-container'><object href={docIframeURL} type="application/pdf" width="100%" height="100%" /></div>);
      var fallBackTxt = !hasPdfPlugin ? /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, BROWSER_SUPPORT_MESSAGE), " ", linkURL, " Or ", /*#__PURE__*/_react.default.createElement("a", {
        href: "http://get.adobe.com/reader/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "click here to install Adobe Reader"), ".") : '';
      var iframeHTML = hasPdfPlugin ? /*#__PURE__*/_react.default.createElement("div", {
        id: "document-container"
      }, /*#__PURE__*/_react.default.createElement("iframe", {
        id: "document-iframe",
        src: docIframeURL
      })) : embedTag;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fallBackTxt, /*#__PURE__*/_react.default.createElement("div", null, iframeHTML));
    }
  }]);
  return DocumentReact;
}(_react.default.Component);
exports.DocumentReact = DocumentReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    document: state.document,
    siteInfo: state.siteInfo
  };
};
DocumentReact.propTypes = {
  document: _propTypes.default.object.isRequired,
  siteInfo: _propTypes.default.object.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Document = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DocumentReact);
exports.Document = Document;
